import ChildlessPlaceholderUi from './ui/childless-placeholder-ui'

export default ChildlessPlaceholderUi
